import React from 'react';
import { TranslationKey } from '../../../types/translation/TranslationKey';
import { t } from '../../../types/translation/Translator';
import { IconType } from '../Icon';
import IconButton, { IconButtonTemplateProps } from '../IconButton';

export default function SettingsIconButton(props: IconButtonTemplateProps) {
  return <IconButton type={IconType.settings1} {...props} text={t(TranslationKey.settings).singular.upper} />;
}
